import { toAbsoluteUrl } from "../_metronic/_helpers";

export function getInitMenuList(intl) {
  const MENU_LIST = [
    {
      // to: "/transactions",
      title: intl.formatMessage({
        id: "MENU.TRANSACTIONS",
        defaultMessage: "Transactions",
      }),
      subMenu: [
        {
          to: "/transactions/inventories/",
          title: intl.formatMessage({
            id: "MENU.TRANSACTIONS.INVENTORY",
            defaultMessage: "Inventory",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Shopping/Box3.svg"),
          accessId: "inventory_list",
        },
        {
          to: "/transactions/tagprints/",
          title: intl.formatMessage({
            id: "MENU.TRANSACTIONS.TAGPRINT",
            defaultMessage: "Tag Print",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Devices/Printer.svg"),
          accessId: "tag_print",
        },
        {
          to: "/transactions/stockAudits/",
          title: intl.formatMessage({
            id: "MENU.TRANSACTIONS.AUDIT",
            defaultMessage: "Stock Audit",
          }),
          svgSource: toAbsoluteUrl(
            "/media/svg/icons/Communication/Clipboard-check.svg"
          ),
          accessId: "stockAudit_list",
        },
        // {
        //     to: "/transactions/stocktransfer",
        //     title: intl.formatMessage({ id: "MENU.TRANSACTIONS.STOCK_TRANSFER", defaultMessage: "Stock Transfer" }),
        //     svgSource: toAbsoluteUrl("/media/svg/icons/Navigation/Exchange.svg"),
        // },
        {
          to: "/transactions/storeApprovals",
          title: intl.formatMessage({
            id: "MENU.TRANSACTIONS.STORE_APPROVAL",
            defaultMessage: "Store Approvals",
          }),
          svgSource: toAbsoluteUrl(
            "/media/svg/icons/Navigation/Double-check.svg"
          ),
          subMenu: [
            {
              to: "/transactions/storeApprovals/store",
              title: intl.formatMessage({
                id: "MENU.TRANSACTIONS.STORE_APPROVAL.STORE",
                defaultMessage: "Store",
              }),
              accessId: "storeApproval_list",
            },
            {
              to: "/transactions/storeApprovals/item",
              title: intl.formatMessage({
                id: "MENU.TRANSACTIONS.STORE_APPROVAL.ITEM",
                defaultMessage: "Item",
              }),
              // accessId: "subscription_create",
            },
          ],
        },
      ],
    },
    {
      // to: "/transactions",
      title: intl.formatMessage({
        id: "MENU.REPORTS",
        defaultMessage: "Reports",
      }),
      subMenu: [
        {
          to: "/reports/inventory",
          title: intl.formatMessage({
            id: "MENU.REPORTS.INVENTORY",
            defaultMessage: "Inventory",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Files/File-inventory.svg"),
          accessId: "inventoryReport_view",
        },
        {
          to: "/reports/inventory-transaction",
          title: intl.formatMessage({
            id: "MENU.REPORTS.INVENTORY_TRANSACTION",
            defaultMessage: "Inventory Transaction",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Files/File-inventory.svg"),
          accessId: "inventoryReport_view",
        },
        {
          to: "/reports/summary-inventory",
          title: intl.formatMessage({
            id: "MENU.REPORTS.INVENTORY_SUMMARY",
            defaultMessage: "Inventory Summary",
          }),
          svgSource: toAbsoluteUrl(
            "/media/svg/icons/Files/File-inventory2.svg"
          ),
          accessId: "inventoryReport_view",
        },
        {
          to: "/reports/transactions",
          title: intl.formatMessage({
            id: "MENU.REPORTS.TRANSACTIONS",
            defaultMessage: "Transactions",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Files/File-store2.svg"),
          accessId: "inventoryReport_view",
        },
        {
          to: "/reports/sales",
          title: intl.formatMessage({
            id: "MENU.REPORTS.SALES",
            defaultMessage: "Sales",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Files/File-money.svg"),
          accessId: "inventoryReport_view",
        },
        {
          to: "/reports/merchant-store",
          title: intl.formatMessage({
            id: "MENU.REPORTS.MERCHANT_STORE",
            defaultMessage: "Merchant Store",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Files/File-store.svg"),
          subMenu: [
            {
              to: "/reports/merchant-store/items",
              title: "Items",
              accessId: "merchantItem_list",
            },
            {
              to: "/reports/merchant-store/summary",
              title: "Summary",
              accessId: "merchantItem_list",
            },
          ],
        },
        // {
        //   to: "/reports/merchant-store-summary",
        //   title: intl.formatMessage({
        //     id: "MENU.REPORTS.MERCHANT_STORE_SUMMARY",
        //     defaultMessage: "Merchant Store Summary",
        //   }),
        //   svgSource: toAbsoluteUrl("/media/svg/icons/Files/File-store2.svg"),
        //   accessId: "inventoryReport_view",
        // },
        {
          to: "/reports/users",
          title: intl.formatMessage({
            id: "MENU.REPORTS.USERS",
            defaultMessage: "Users",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Files/File-user.svg"),
          accessId: "inventoryReport_view",
        },
      ],
    },
    {
      // to: "/accounting",
      title: intl.formatMessage({
        id: "MENU.ACCOUNTING",
        defaultMessage: "Accounting",
      }),
      subMenu: [
        // {
        //   to: "/accounting/subscriptions",
        //   title: intl.formatMessage({
        //     id: "MENU.ACCOUNTING.SUBSCRIPTION",
        //     defaultMessage: "Subscriptions",
        //   }),
        //   svgSource: toAbsoluteUrl(
        //     "/media/svg/icons/Communication/Chat-check.svg"
        //   ),
        //   subMenu: [
        //     {
        //       to: "/accounting/subscriptions/viewall",
        //       title: intl.formatMessage({
        //         id: "MENU.COMMON.VIEW_ALL",
        //         defaultMessage: "View All",
        //       }),
        //       accessId: "subscription_list",
        //     },
        //     {
        //       to: "/accounting/subscriptions/create",
        //       title: intl.formatMessage({
        //         id: "MENU.COMMON.CREATE",
        //         defaultMessage: "Create",
        //       }),
        //       accessId: "subscription_create",
        //     },
        //   ],
        // },
        {
          to: "/accounting/products",
          title: intl.formatMessage({
            id: "MENU.ACCOUNTING.SUBSCRIPTION_PRODUCT",
            defaultMessage: "Subscription Plans",
          }),
          svgSource: toAbsoluteUrl(
            "/media/svg/icons/Communication/Chat-check.svg"
          ),
          subMenu: [
            {
              to: "/accounting/products/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "product_list",
            },
            {
              to: "/accounting/products/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "product_create",
            },
          ],
        },
        {
          to: "/accounting/links",
          title: intl.formatMessage({
            id: "MENU.ACCOUNTING.SUBSCRIPTION_LINK",
            defaultMessage: "Subscription Links",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Navigation/Exchange.svg"),
          subMenu: [
            {
              to: "/accounting/links/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "productLink_list",
            },
            {
              to: "/accounting/links/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "productLink_create",
            },
          ],
        },
        {
          to: "/accounting/bonus",
          title: intl.formatMessage({
            id: "MENU.ACCOUNTING.SUBSCRIPTION_BONUS",
            defaultMessage: "Subscription Bonuses",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Shopping/Sale2.svg"),
          subMenu: [
            {
              to: "/accounting/bonus/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "productBonus_list",
            },
            {
              to: "/accounting/bonus/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "productBonus_create",
            },
          ],
        },
        {
          to: "/accounting/cashflows",
          title: intl.formatMessage({
            id: "MENU.ACCOUNTING.CASHFLOW",
            defaultMessage: "Cash Flows",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Shopping/Money.svg"),
          subMenu: [
            {
              to: "/accounting/cashflows/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "cashFlow_list",
            },
            {
              to: "/accounting/cashflows/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "cashFlow_create",
            },
          ],
        },
        {
          to: "/accounting/cashFlowSubscriptions",
          title: intl.formatMessage({
            id: "MENU.ACCOUNTING.CASHFLOW_SUBSCRIPTION",
            defaultMessage: "Cash Flow Subscription",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Shopping/Safe.svg"),
          subMenu: [
            {
              to: "/accounting/cashFlowSubscriptions/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "cashFlowProduct_list",
            },
            {
              to: "/accounting/cashFlowSubscriptions/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "cashFlowProduct_create",
            },
          ],
        },
        {
          to: "/accounting/mobileUsers",
          title: intl.formatMessage({
            id: "MENU.ACCOUNTING.MOBILE_USERS",
            defaultMessage: "Mobile Users",
          }),
          svgSource: toAbsoluteUrl(
            "/media/svg/icons/Communication/Chat-check.svg"
          ),
        },
      ],
    },

    // {
    //   title: intl.formatMessage({
    //     id: "MENU.REPORTING",
    //     defaultMessage: "Reporting",
    //   }),
    //   subMenu: [
    //     {
    //       to: "/reporting/inventory",
    //       title: intl.formatMessage({
    //         id: "MENU.REPORTING.INVENTORY",
    //         defaultMessage: "Inventory",
    //       }),
    //       svgSource: toAbsoluteUrl("/media/svg/icons/Shopping/Chart-bar1.svg"),
    //     },
    //   ],
    // },

    {
      // to: "/configurations",
      title: intl.formatMessage({
        id: "MENU.CONFIGURATIONS",
        defaultMessage: "Configurations",
      }),
      subMenu: [
        {
          to: "/configurations/organizations",
          title: intl.formatMessage({
            id: "MENU.CONFIGURATIONS.ORGANIZATIONS",
            defaultMessage: "Organizations",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Home/Earth.svg"),
          subMenu: [
            {
              to: "/configurations/organizations/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "organization_list",
            },
            {
              to: "/configurations/organizations/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "organization_create",
            },
          ],
        },
        {
          to: "/configurations/locations",
          title: intl.formatMessage({
            id: "MENU.CONGIGURATIONS.LOCATIONS",
            defaultMessage: "Locations",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Map/Marker2.svg"),
          subMenu: [
            {
              to: "/configurations/locations/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "location_list",
            },
            {
              to: "/configurations/locations/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "location_create",
            },
          ],
        },
        {
          to: "/configurations/bintypes",
          title: intl.formatMessage({
            id: "MENU.CONFIGURATIONS.BIN_TYPES",
            defaultMessage: "Bin Types",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Home/Cupboard.svg"),
          subMenu: [
            {
              to: "/configurations/bintypes/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "binType_list",
            },
            {
              to: "/configurations/bintypes/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "binType_create",
            },
          ],
        },
        {
          to: "/configurations/bins",
          title: intl.formatMessage({
            id: "MENU.CONFIGURATIONS.BINS",
            defaultMessage: "Bins",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Home/Trash.svg"),
          subMenu: [
            {
              to: "/configurations/bins/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "bin_list",
            },
            {
              to: "/configurations/bins/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "bin_create",
            },
          ],
        },
        {
          to: "/configurations/merchants",
          title: intl.formatMessage({
            id: "MENU.CONFIGURATIONS.MERCHANTS",
            defaultMessage: "Merchants",
          }),
          svgSource: toAbsoluteUrl(
            "/media/svg/icons/Communication/Address-card.svg"
          ),
          subMenu: [
            {
              to: "/configurations/merchants/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "merchant_list",
            },
            {
              to: "/configurations/merchants/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "merchant_create",
            },
          ],
        },
        {
          to: "/configurations/stores",
          title: intl.formatMessage({
            id: "MENU.CONFIGURATIONS.STORES",
            defaultMessage: "Stores",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Home/Home-heart.svg"),
          subMenu: [
            {
              to: "/configurations/stores/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "store_list",
            },
            {
              to: "/configurations/stores/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "store_create",
            },
          ],
        },
        {
          to: "/configurations/items",
          title: intl.formatMessage({
            id: "MENU.CONFIGURATIONS.ITEMS",
            defaultMessage: "Items",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Shopping/Bag1.svg"),
          subMenu: [
            {
              to: "/configurations/items/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "item_list",
            },
            {
              to: "/configurations/items/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "item_create",
            },
          ],
        },
        {
          to: "/configurations/itemtypes",
          title: intl.formatMessage({
            id: "MENU.CONFIGURATIONS.ITEM_TYPE",
            defaultMessage: "Item Types",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Shopping/Box2.svg"),
          subMenu: [
            {
              to: "/configurations/itemtypes/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "itemType_list",
            },
            {
              to: "/configurations/itemtypes/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "itemType_create",
            },
          ],
        },
        {
          to: "/configurations/warehouses",
          title: intl.formatMessage({
            id: "MENU.CONFIGURATIONS.WAREHOUSES",
            defaultMessage: "Warehouses",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Home/Home.svg"),
          subMenu: [
            {
              to: "/configurations/warehouses/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "warehouse_list",
            },
            {
              to: "/configurations/warehouses/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "warehouse_create",
            },
          ],
        },

        {
          to: "/configurations/transporters",
          title: intl.formatMessage({
            id: "MENU.CONFIGURATIONS.TRANSPORTERS",
            defaultMessage: "Transporters",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Shopping/Loader.svg"),
          subMenu: [
            {
              to: "/configurations/transporters/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "transporter_list",
            },
            {
              to: "/configurations/transporters/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "transporter_create",
            },
          ],
        },

        {
          to: "/configurations/dishwashers",
          title: intl.formatMessage({
            id: "MENU.CONFIGURATIONS.DISHWASHERS",
            defaultMessage: "Dishwashers",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Electric/Washer.svg"),
          subMenu: [
            {
              to: "/configurations/dishwashers/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "dishwasher_list",
            },
            {
              to: "/configurations/dishwashers/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "dishwasher_create",
            },
          ],
        },
        {
          to: "/configurations/companies",
          title: intl.formatMessage({
            id: "MENU.CONGIGURATIONS.COMPANIES",
            defaultMessage: "Companies",
          }),
          svgSource: toAbsoluteUrl("/media/svg/icons/Home/Building.svg"),
          subMenu: [
            {
              to: "/configurations/companies/viewall",
              title: intl.formatMessage({
                id: "MENU.COMMON.VIEW_ALL",
                defaultMessage: "View All",
              }),
              accessId: "organization_list",
            },
            {
              to: "/configurations/companies/create",
              title: intl.formatMessage({
                id: "MENU.COMMON.CREATE",
                defaultMessage: "Create",
              }),
              accessId: "organization_create",
            },
          ],
        },
      ],
    },
  ];

  const Menu_List = MENU_LIST.map((menu) => {
    if (menu.accessKeys) return menu;

    if (menu.subMenu) {
      let menuContent = menu.subMenu.map((menu2) => {
        if (menu2.accessKeys) return menu2;

        if (menu2.accessId) {
          if (!menu.accessKeys) menu.accessKeys = [];
          menu.accessKeys.push(menu2.accessId);
        }

        if (menu2.subMenu) {
          let menu2Content = menu2.subMenu.map((menu3) => {
            if (menu3.accessKeys) return menu3;

            if (menu3.accessId) {
              if (!menu2.accessKeys) menu2.accessKeys = [];
              menu2.accessKeys.push(menu3.accessId);
            }

            return menu3;
          });

          menu2.subMenu = menu2Content;
        }

        if (menu2.accessKeys) {
          if (!menu.accessKeys) menu.accessKeys = [];
          menu.accessKeys.push(...menu2.accessKeys);
        }

        return menu2;
      });

      menu.subMenu = menuContent;
    }

    return menu;
  });

  return Menu_List;
}
